import React, { useRef } from "react";
// import { saveAs } from "file-saver"; // For saving PDF
// import html2canvas from "html2canvas"; // For converting HTML to canvas
import { jsPDF } from "jspdf"; // For creating PDF
import type { jsPDF as jsPDFType } from "jspdf";
import "jspdf-autotable";
import useUserStore from "./Stores/userStore";
import { format } from "date-fns";
import {
  currencyFormat,
  formatPhone,
  toFixedDecimal,
  updateSingleItemToBucket,
} from "./CommonFunctions";
import ImgPlaceholder from "@/assets/placeholder.png";
import { applyPlugin } from "jspdf-autotable";
import useProjectStore from "./Stores/projectStore";

import {
  aptosBase64,
  aptosBoldBase64,
  aptosSemiBoldBase64,
} from "@/utils/Fonts/aptos-base64";
applyPlugin(jsPDF);

export default function GeneratePDF(props) {
  const { shippingAddress, billingAddress, products } = props;

  const iframeRef = useRef(null);

  const handleSendToClient = () => {
    // Implement email functionality here
    console.log("Sending invoice to client...");
  };
  return (
    <div className="">
      <div id="header" className=" hidden">
        <img src="company-logo.png" alt="Company Logo" />
        <h1>Company Name</h1>
        <p>Address Line 1</p>
        <p>Address Line 2</p>
        <p>Contact: +1234567890</p>
        <hr />
      </div>

      <div className=" flex gap-4">
        {/* Button to export PDF */}
        <button
          onClick={() =>
            handlePDFExport(
              shippingAddress,
              billingAddress,
              products,
              iframeRef
            )
          }
        >
          Export PDF
        </button>

        {/* Button to send invoice to client */}
        <button onClick={handleSendToClient}>Send to Client</button>
      </div>

      <iframe
        ref={iframeRef}
        width="100%"
        height="600px"
        title="PDF Preview"
      ></iframe>
    </div>
  );
}

const loadFontFromCDN = async () => {
  const fontUrl =
    "https://cdn.jsdelivr.net/gh/rsms/inter/font-files/Inter-Regular.ttf";

  // Fetch the font from the CDN
  const response = await fetch(fontUrl);
  const fontBuffer = await response.arrayBuffer();

  // Convert the font to a Base64 string
  const base64Font = btoa(String.fromCharCode(...new Uint8Array(fontBuffer)));

  return base64Font;
};

// export const handlePDFExport = (

//   companyName: string,
//   shippingAddress: any,
//   billingAddress: any,
//   data: any,
//   vendorId?: any,
//   client?: any,
//   from?: string,
//   user?: any
// ) => {
//   const pdf: any = new jsPDF();

//   // const interFontBase64 = await loadFontFromCDN();

//   // // Add and register the font
//   // pdf.addFileToVFS("Inter-Regular.ttf", interFontBase64);
//   // pdf.addFont("Inter-Regular.ttf", "Inter", "normal");

//   // Define positions and dimensions
//   const leftColumnX = 14;
//   const rightColumnX = 120;
//   const startY = 10;
//   const lineSpacing = 6;

//   let currentY1 = startY + 10;
//   let currentY2 = startY + 10;
//   // Add company name in the first column
//   pdf.setFont("inter", "bold");
//   pdf.setFontSize(14);
//   pdf.text(companyName, leftColumnX, currentY1);

//   currentY1 = currentY1 + lineSpacing;
//   pdf.setFont("inter", "regular");
//   pdf.text(user.email, leftColumnX, currentY1);
//   currentY1 = currentY1 + lineSpacing;

//   // Add company name in the first column
//   pdf.text(
//     `Due Date: ${format(new Date(data?.dueDate), "MM/dd/yy")}`,
//     rightColumnX,
//     currentY2
//   );

//   currentY2 = currentY2 + lineSpacing;
//   const itemName =
//     from === "purchaseorder"
//       ? "PO"
//       : from === "invoice"
//         ? "Invoice"
//         : "Proposal";
//   pdf.text(`${itemName}: ${data.code}`, rightColumnX, currentY2);
//   currentY2 = currentY2 + lineSpacing;

//   pdf.setLineWidth(0.3);
//   pdf.setDrawColor(200);
//   pdf.line(14, currentY1, 196, currentY2);
//   currentY1 = currentY1 + 10;
//   currentY2 = currentY2 + 10;

//   // Add shipping address below the company name in the first column
//   pdf.setFontSize(14);

//   const shippingAddressLines = [
//     shippingAddress.address_title || "",
//     shippingAddress.address || "",
//     `${shippingAddress.city || ""}, ${shippingAddress.state || ""} ${shippingAddress.zip || ""}`,
//   ];

//   // left column
//   if (from === "purchaseorder") {
//     const vendorToLines = [
//       `Vendor`,
//       data?.vendor?.name || "",
//       data?.vendor?.phone_numbers?.[0] || "",
//     ];

//     vendorToLines.forEach((line) => {
//       const splitLines = pdf.splitTextToSize(line, 90);
//       splitLines.forEach((splitLine) => {
//         pdf.text(splitLine, leftColumnX, currentY1);
//         currentY1 += lineSpacing;
//       });
//     });
//   } else {
//     const billToLines = [
//       `Bill To:`,
//       client?.name || "",
//       client?.phone_numbers?.[0] || "",
//       client?.email || "",
//     ];
//     billToLines.forEach((line) => {
//       const splitLines = pdf.splitTextToSize(line, 90);
//       splitLines.forEach((splitLine) => {
//         pdf.text(splitLine, leftColumnX, currentY1);
//         currentY1 += lineSpacing;
//       });
//     });
//   }

//   //right
//   const billingAddressLines = [
//     billingAddress.address_title || "",
//     billingAddress.address || "",
//     `${billingAddress.city || ""}, ${billingAddress.state || ""} ${billingAddress.zip || ""}`,
//   ];

//   if (from === "invoice" || from === "proposal") {
//     pdf.text("Billing Address", rightColumnX, currentY2);
//     currentY2 = currentY2 + lineSpacing;

//     billingAddressLines.forEach((line, index) => {
//       //  pdf.text(line, rightColumnX, billingAddressStartY + index * lineSpacing);
//       const splitLines = pdf.splitTextToSize(line, 90);
//       splitLines.forEach((splitLine) => {
//         pdf.text(splitLine, rightColumnX, currentY2);
//         currentY2 += lineSpacing;
//       });
//     });
//   } else {
//     pdf.text("Ship To", rightColumnX, currentY2);
//     currentY2 += lineSpacing;

//     shippingAddressLines.forEach((line) => {
//       const splitLines = pdf.splitTextToSize(line, 90);
//       splitLines.forEach((splitLine) => {
//         pdf.text(splitLine, rightColumnX, currentY2);
//         currentY2 += lineSpacing;
//       });
//     });
//   }

//   // Add company details below the billing address in the second column
//   // const companyDetailsStartY =
//   //   billingAddressStartY +
//   //   billingAddressLines.length * lineSpacing +
//   //   lineSpacing;
//   // const companyDetailsLines = companyDetails.split("\n");
//   // companyDetailsLines.forEach((line, index) => {
//   //   pdf.text(line, rightColumnX, companyDetailsStartY + index * lineSpacing);
//   // });

//   // Calculate the Y position for the table
//   let tableStartY = Math.max(
//     currentY1
//     //companyDetailsStartY + companyDetailsLines.length * lineSpacing + 1
//   );

//   let currentY = tableStartY + lineSpacing;
//   pdf.setLineWidth(0.3);
//   pdf.setDrawColor(200);
//   pdf.line(14, currentY, 196, currentY);

//   tableStartY = tableStartY + lineSpacing + 10;

//   //const imgHeight = 0;
//   //const previousContentHeight = 40; // Adjust this value based on the height of the previous content
//   //const imageYPosition = previousContentHeight + 10; // Add some padding

//   // const items = invoiceData.itemList;
//   // const startYPosition = imageYPosition + imgHeight + 10; // Start Y position after the image
//   const tableHeaders = ["Image", "Description", "Price", "Quantity"];
//   // new code
//   //const tableRows = [];
//   // products.forEach((product) => {
//   //   const productData = [
//   //     {
//   //       content: product.image,
//   //       styles: { cellWidth: 40, halign: "center", valign: "middle" },
//   //     },
//   //     {
//   //       content: `${product.name}\n${product.description.trim()}`,
//   //       styles: { fontStyle: "normal", halign: "left", valign: "top" },
//   //     },

//   //     `$${product.price.toFixed(2)}`,
//   //     product.quantity,
//   //   ];
//   //   tableRows.push(productData);
//   // });
//   // const addImage = async (data) => {
//   //   for (let i = 1; i < data.table.body.length; i++) {
//   //     const imageUrl = data.table.body[i - 1]?.raw?.[0]?.content;
//   //     if (imageUrl) {
//   //       const imgData = await fetchImageAsBase64(imageUrl);
//   //       console.log("test--", data.table.body[i - 1]);
//   //       // pdf.addImage(imgData, "JPEG", data.cell.x + 2, data.cell.y + 2, 16, 16);
//   //       pdf.text("test", data.cell.x + 2, data.cell.y + 2);
//   //     }
//   //   }
//   // };

//   pdf.autoTable({
//     startY: tableStartY,
//     // head: [tableHeaders],
//     // body: tableRows,
//     html: vendorId ? `#mytable-${vendorId}` : "#mytable",
//     didDrawCell: async (data) => {
//       if (data.column.index === 0 && data.cell.section === "body") {
//         var td = data.cell.raw;
//         var img = td.getElementsByTagName("img")[0];
//         var dim = data.cell.height - data.cell.padding("vertical");

//         // const response = await imageUrlToBase64(img.src);
//         if (img.src) {
//           pdf.addImage(img.src, "", data.cell.x + 2, data.cell.y + 2, 15, 15);
//         }
//       }
//       // if (data.column.index === 5 && data.cell.section === "body") {
//       //   // addImage(data);
//       //   const imageUrl = data?.cell?.raw;

//       //   if (imageUrl) {
//       //     pdf.addImage(
//       //       imageUrl,
//       //       "JPEG",
//       //       data.cell.x + 2,
//       //       data.cell.y + 2,
//       //       16,
//       //       16
//       //     );
//       //   }
//       // }
//       if (data.cell.section === "head") {
//         data.cell.styles.lineWidth = 0.5;
//         data.cell.styles.lineColor = [0, 0, 0];
//       }
//     },
//     theme: "grid",
//     headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
//     bodyStyles: { fillColor: [255, 255, 255] },
//   });

//   const finalY = pdf.lastAutoTable.finalY || 10;
//   const pageHeight = pdf.internal.pageSize.height;
//   const margin = 10;
//   const footerTextHeight = 4 * 6; // 4 lines of text, each roughly 6 units high

//   // if (finalY + margin + footerTextHeight > pageHeight) {
//   //   pdf.addPage();
//   // }

//   currentY = finalY + margin;
//   // Add notes on the left column
//   //   const notes = `
//   // Notes:
//   // - Note 1
//   // - Note 2
//   // - Note 3
//   // `;
//   //   const notesLines = notes.trim().split("\n");
//   //   notesLines.forEach((line, index) => {
//   //     pdf.text(line, 14, currentY + index * 6);
//   //   });
//   const { subTotal, shippingCost } = CalculateTaxAndPrice(
//     data?.specifications,
//     vendorId || from == "purchaseorder" ? "purchaseorder" : ""
//   );
//   // const subTotal = data?.specifications?.reduce(
//   //   (acc, item) => acc + (+item?.totalSellingPrice || 0),
//   //   0
//   // );
//   // const shipping = data?.specifications?.reduce(
//   //   (acc, item) => acc + (+item?.shippingCost || 0),
//   //   0
//   // );

//   const financialDetailsStartY = currentY;
//   pdf.setFontSize(12);

//   pdf.text(
//     `Sub Total: $${toFixedDecimal(subTotal)}`,
//     160,
//     financialDetailsStartY
//   );
//   pdf.text(
//     `Markup: ${toFixedDecimal(data?.markup || 0)}%`,
//     160,
//     financialDetailsStartY + 6
//   );
//   pdf.text(
//     `Tax: $${toFixedDecimal(data?.tax || 0)}`,
//     160,
//     financialDetailsStartY + 12
//   );

//   pdf.text(
//     `Shipping: $${toFixedDecimal(shippingCost || 0)}`,
//     160,
//     financialDetailsStartY + 18
//   );

//   pdf.text(
//     `Total: $${TotalPrice(subTotal, shippingCost, data.markup, data.tax)}`,
//     160,
//     financialDetailsStartY + 24
//   );
//   // pdf.text(`Deposits/Payments:`, 120, financialDetailsStartY + 24);
//   // pdf.text(`Less Dep./Payments Total:`, 120, financialDetailsStartY + 30);
//   // pdf.text(`Grand Total:`, 120, financialDetailsStartY + 36);

//   currentY = financialDetailsStartY + 46;
//   pdf.setLineWidth(0.5);
//   pdf.line(14, currentY, 196, currentY);
//   if (data?.termsConditions) {
//     const decodedContent = decodeHTML(data?.termsConditions);
//     pdf.text(`Terms & Conditions:`, 14, currentY + 10);
//     currentY = currentY + 16;
//     const splitLines = pdf.splitTextToSize(decodedContent, 180);
//     splitLines.forEach((splitLine) => {
//       if (currentY + lineSpacing > pageHeight - margin) {
//         pdf.addPage(); // Add a new page
//         currentY = margin; // Reset Y position
//       }

//       pdf.text(splitLine, 14, currentY);
//       currentY += lineSpacing;
//     });
//   }

//   if (data?.memo) {
//     pdf.text(`Memo:`, 14, currentY + 10);
//     currentY = currentY + 16;
//     const splitLines = pdf.splitTextToSize(data?.memo, 180);
//     splitLines.forEach((splitLine) => {
//       if (currentY + lineSpacing > pageHeight - margin) {
//         pdf.addPage(); // Add a new page
//         currentY = margin; // Reset Y position
//       }

//       pdf.text(splitLine, 14, currentY);
//       currentY += lineSpacing;
//     });
//   }

//   // const footerText = `
//   // THIS IS NOT AN ${from}.
//   // For a final ${from} and payment instructions, please email trade@trnk-nyc.com.
//   // Please note, pricing and lead times are subject to change after 48 hours. Lead times can vary depending on availability and the timing of receipt of payment.
//   // `;

//   // Check if there's enough space on the current page
//   //const additionalTextHeight = footerText.trim().split("\n").length * 6;
//   // const finalPositionY =
//   //   Math.max(currentY, financialDetailsStartY + 40) + margin;

//   // if (finalPositionY + additionalTextHeight > pageHeight) {
//   //   pdf.addPage();
//   //   currentY = margin; // Reset the Y position for the new page
//   // } else {
//   //   currentY = finalPositionY;
//   // }
//   // const footerLines = footerText.trim().split("\n");
//   // footerLines.forEach((line, index) => {
//   //   pdf.text(line, 14, currentY + index * 6, { maxWidth: 190 });
//   // });

//   // Generate the PDF file as a Blob
//   const pdfBlob = pdf.output("blob");

//   // const pdfUrl = URL.createObjectURL(pdfBlob);

//   // // Set the Blob URL to the iframe's src to preview the PDF
//   // if (iframeRef?.current) {
//   //   iframeRef.current.src = pdfUrl;
//   // }

//   // pdf.save("invoice.pdf");
//   // return pdfUrl;

//   return pdfBlob;
//   // Create a Blob URL from the PDF file
// };

// ... existing code ...
const maps = {
  invoice: "Invoice",
  proposal: "Proposal",
  purchaseorder: "Purchase Order",
  retainer: "Retainer",
  memo: "Credit Memo",
};

export const handlePDFExport = async (
  shippingAddress: any,
  billingAddress: any,
  data: any,
  vendorId?: any,
  client?: any,
  from?: string
) => {
  const pdf: jsPDFType = new jsPDF();
  const pageHeight = pdf.internal.pageSize.height;
  const pageWidth = pdf.internal.pageSize.getWidth();
  const margin = 25;
  const companyInfo = useUserStore.getState()?.user;
  const projectData = useProjectStore.getState()?.projectData;
  let startY = 38;
  pdf.addFileToVFS("Aptos.ttf", aptosBase64);
  pdf.addFont("Aptos.ttf", "Aptos", "normal");

  pdf.addFileToVFS("Aptos-Bold.ttf", aptosBoldBase64);
  pdf.addFont("Aptos-Bold.ttf", "Aptos", "bold");
  pdf.addFileToVFS("Aptos-SemiBold.ttf", aptosSemiBoldBase64);
  pdf.addFont("Aptos-SemiBold.ttf", "Aptos", "semibold");
  // Header section
  pdf.setFontSize(24);
  pdf.setTextColor(0, 0, 0);

  if (companyInfo?.company_details?.base64CompanyLogo) {
    try {
      // const imgData = await fetchImageAsBase64(companyInfo.company_logo);
      const imgData: any = await drawCircularImage(
        pdf,
        companyInfo.company_details?.base64CompanyLogo ||
          companyInfo.company_details.logo,
        14,
        10,
        22
      );
      pdf.addImage(imgData, "PNG", 14, 10, 22, 22);

      // Adjust position and size as needed
      //pdf.addImage(imgData, "PNG", 14, 10, 20, 20, undefined, "FAST");
      // pdf.text(companyInfo?.company_details?.name || "Genus Tech", 45, 23); // Adjust x position to make space for the logo
      pdf.setFontSize(10);

      if (companyInfo?.company_details?.phone_number) {
        pdf.text(
          formatPhone(companyInfo?.company_details?.phone_number),
          14,
          startY
        );
        startY += 5;
      }
      if (companyInfo?.company_details?.email) {
        pdf.text(companyInfo?.company_details?.email, 14, startY);
        startY += 5;
      }
    } catch (error) {
      console.error("Error loading company logo:", error);
      startY = 23;
      pdf.text(companyInfo?.company_details?.name || "Genus Tech", 14, startY);
      pdf.setFontSize(10);
      startY += 5;

      if (companyInfo?.company_details?.phone_number) {
        pdf.text(
          formatPhone(companyInfo?.company_details?.phone_number),
          14,
          startY
        );
        startY += 5;
      }
      if (companyInfo?.company_details?.email) {
        pdf.text(companyInfo?.company_details?.email, 14, startY);
        startY += 5;
      }
    }
  } else {
    startY = 23;
    pdf.text(companyInfo?.company_details?.name || "Genus Tech", 14, startY);
    pdf.setFontSize(10);
    startY += 5;

    if (companyInfo?.company_details?.phone_number) {
      pdf.text(
        formatPhone(companyInfo?.company_details?.phone_number),
        14,
        startY
      );
      startY += 5;
    }
    if (companyInfo?.company_details?.email) {
      pdf.text(companyInfo?.company_details?.email, 14, startY);
      startY += 5;
    }
    if (
      !companyInfo?.company_details?.phone_number ||
      !companyInfo?.company_details?.email
    ) {
      if (!companyInfo?.company_details?.email) {
        startY += 5;
      }
      if (!companyInfo?.company_details?.phone_number) {
        startY += 5;
      }
    }
  }
  pdf.setFont("Aptos", "bold");
  pdf.text(
    `${maps[from]?.toUpperCase()}: ${data.code?.toUpperCase() || ""}`,
    from == "purchaseorder" ? 140 : 150,
    15
  );
  pdf.setFont("Aptos", "normal");
  pdf.setFontSize(10);
  pdf.text(
    `Date: ${format(new Date(), "MM/dd/yyyy")}`,
    from == "purchaseorder" ? 140 : 150,
    20
  );
  if (from !== "purchaseorder") {
    pdf.text(
      `Due Date: ${data?.dueDate ? format(new Date(data?.dueDate), "MM/dd/yy") : ""}`,
      from == "purchaseorder" ? 140 : 150,
      25
    );
  }

  // Paid stamp (if needed)
  // if (data.status?.toLowerCase() === "paid") {
  //   pdf.setDrawColor(39, 174, 96); // Green color
  //   pdf.setLineWidth(1);
  //   pdf.rect(155, 12, 40, 20);
  //   pdf.setTextColor(39, 174, 96);
  //   pdf.setFontSize(16);
  //   pdf.text("PAID", 170, 24);
  // }

  // Date
  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(10);
  // pdf.text(format(new Date(data?.dueDate), "MM/dd/yyyy"), 170, 20);

  // Divider line
  pdf.setLineWidth(0.1);
  pdf.setDrawColor(200, 200, 200);
  pdf.line(14, startY, 196, startY);

  startY += 8;
  // Vendor/Ship To section
  pdf.setFontSize(12);
  pdf.setFont("Aptos", "semibold");
  //pdf.text("VENDOR", 14, 65);
  pdf.text(from === "purchaseorder" ? "To:" : "Bill To:", 14, startY);

  pdf.text(
    from === "purchaseorder" ? "Ship To:" : "Project Site:",
    120,
    startY
  );
  //pdf.text(maps[from], 150, 50);

  // Vendor details
  pdf.setFont("Aptos", "normal");
  pdf.setFontSize(12);
  if (from === "purchaseorder") {
    const primaryAddress = data?.vendor?.address?.find(
      (item) => item.isPrimary === true
    );
    pdf.text(
      [
        data?.vendor?.company || data?.vendor?.name || "",
        primaryAddress?.address || "",
        [
          primaryAddress?.city || "",
          primaryAddress?.city && primaryAddress?.state ? ", " : "",
          primaryAddress?.state || "",
          (primaryAddress?.city || primaryAddress?.state) && primaryAddress?.zip
            ? " "
            : "",
          primaryAddress?.zip || "",
        ].join(""),
      ],
      25,
      startY
    );
  } else {
    pdf.text(
      [
        client?.name || "",
        billingAddress?.address || "",
        [
          billingAddress?.city || "",
          billingAddress?.city && billingAddress?.state ? ", " : "",
          billingAddress?.state || "",
          (billingAddress?.city || billingAddress?.state) && billingAddress?.zip
            ? " "
            : "",
          billingAddress?.zip || "",
        ].join(""),
      ],
      35,
      startY
    );
  }

  if (from === "purchaseorder") {
    pdf.text(
      [
        client?.name || "",
        billingAddress?.address || "",
        [
          billingAddress?.city || "",
          billingAddress?.city && billingAddress?.state ? ", " : "",
          billingAddress?.state || "",
          (billingAddress?.city || billingAddress?.state) && billingAddress?.zip
            ? " "
            : "",
          billingAddress?.zip || "",
        ].join(""),
      ],
      140,
      startY
    );
  } else {
    pdf.text(
      [
        projectData?.client?.name || "",
        projectData?.client?.address?.[0]?.address || "",
        [
          projectData?.client?.address?.[0]?.city || "",
          projectData?.client?.address?.[0]?.city &&
          projectData?.client?.address?.[0]?.state
            ? ", "
            : "",
          projectData?.client?.address?.[0]?.state || "",
          (projectData?.client?.address?.[0]?.city ||
            projectData?.client?.address?.[0]?.state) &&
          projectData?.client?.address?.[0]?.zip
            ? " "
            : "",
          projectData?.client?.address?.[0]?.zip || "",
        ].join(""),
      ],
      150,
      startY
    );
  }

  // Order number

  // Table headers
  startY += 30;

  pdf.autoTable({
    startY: startY,
    // head: [tableHeaders],
    // body: tableRows,
    html: vendorId ? `#mytable-${vendorId}` : "#mytable",
    didDrawCell: async (data) => {
      if (data.column.index === 0 && data.cell.section === "body") {
        var td = data.cell.raw;
        var img = td.getElementsByTagName("img")[0];

        if (img.src) {
          pdf.addImage(
            img.src,
            "",
            data.cell.x + 2,
            data.cell.y + 4,
            25,
            25,
            undefined,
            "FAST"
          );
        }
      }
      if (data.section === "head") {
        const { cell } = data;
        const { x, y, width, height } = cell;

        const pdf = data.doc;

        // Draw top border
        pdf.setLineWidth(0.1);
        pdf.setDrawColor(200, 200, 200); // Gray color
        pdf.line(x, y, x + width, y);

        // Draw bottom border
        pdf.line(x, y + height, x + width, y + height);
      } else if (data.section === "body") {
        const { cell } = data;
        const { x, y, width, height } = cell;
        // console.log("didDrawCell", cell);
        const doc = data.doc;
        doc.setLineWidth(0.2);
        doc.setDrawColor(102, 102, 102); // Gray color
        doc.line(x, y + height, x + width, y + height);

        // Draw bottom border for body cells with margin
        const tempX = data.cell.x + 2;
        let tempY = data.cell.y + 5;
        const cellText =
          (data?.column?.index == 1 && data.row.raw[1].content) || "";
        if (cellText?.includes("\u0001")) {
          const lines = cellText.split("\u0001").map((item) => {
            return {
              label: item?.split(":")[0],
              value: item?.split(":")[1] || "",
            };
          });

          lines.forEach((line, index) => {
            if (index == 0) {
              doc.setFont("Aptos", "normal");
              doc.setTextColor(0, 0, 0); // Black color
              doc.text(line.label, tempX, tempY);
            } else {
              doc.setFont("Aptos", "normal");
              doc.setTextColor(145, 150, 160); // Gray color
              doc.text(`${line.label}:`, tempX, tempY);
            }

            const labelWidth = pdf.getTextWidth(line.label) + 1;

            doc.setFont("Aptos", "normal");
            doc.setTextColor(0, 0, 0);

            const { w: textWidth, h: textHeight } = pdf.getTextDimensions(
              line.value
            );

            if (textWidth < width) {
              doc.text(line.value, tempX + labelWidth, tempY);
            } else {
              const splitLines = pdf.splitTextToSize(
                line.value,
                (width || 80) - 10
              );
              splitLines.forEach((splitLine) => {
                doc.text(splitLine, tempX + labelWidth, tempY);
                tempY += 4;
              });
            }

            tempY += 6; //textHeight + 1; // vertical spacing
            if (line.label == "Ref #") {
              tempY += 4;
            }
          });
        }
      }
    },

    didParseCell: (data) => {
      // Handle header cells

      if (data.cell.section === "head") {
        // Set specific header alignments
        if (
          data.column.index === 2 || // QTY column
          data.column.index === 3 || // PRICE column
          data.column.index === 4 // TOTAL column
        ) {
          data.cell.styles.halign = "right";
        } else if (data.column.index === 0 || data.column.index === 1) {
          data.cell.styles.halign = "center";
        }
      } else {
        // if (data.row.index === 0) {
        //   data.cell.styles.cellPadding = [6, 0, 0, 0]; // Regular padding for other columns
        // } else {
        data.cell.styles.cellPadding = [6, 0, 0, 0]; // Regular padding for other columns
        // }

        // Calculate min cell height

        const cellText =
          (data?.column?.index == 1 && data.row.raw[1].content) || "";
        if (cellText?.includes("\u0001")) {
          let tempY = 0;
          const lines = cellText.split("\u0001").map((item) => {
            return {
              label: item?.split(":")[0],
              value: item?.split(":")[1] || "",
            };
          });

          lines.forEach((line) => {
            const { w: textWidth, h: textHeight } = pdf.getTextDimensions(
              line.value
            );

            if (textWidth > (data.cell.styles.cellWidth || 80) - 10) {
              const splitLines = pdf.splitTextToSize(
                line.value,
                (data.cell.styles.cellWidth || 80) - 10
              );
              splitLines.forEach(() => {
                tempY += 4;
              });
            }

            tempY += 6; // vertical spacing
            if (line.label == "Ref #") {
              tempY += 4;
            }
          });

          data.cell.styles.minCellHeight = tempY + 6;
        }
      }

      // Handle body cells
    },
    willDrawCell: (data) => {
      if (data.section === "body" && data.column.index == 1) {
        data.cell.text = ""; // prevent default text to avoid overlapping
      }
    },

    theme: "plain",
    //  headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
    styles: {
      fontSize: 10,
      cellPadding: 2,
      borderBottomWidth: 0.5,
      borderTopWidth: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0,
      minCellHeight: 0,
    },
    headStyles: {},
    columnStyles: {
      0: { cellWidth: 30, border: "none" },
      1: { cellWidth: 80, halign: "left" },
      2: { cellWidth: "auto", halign: "right" },
      3: { cellWidth: "auto", halign: "right" },
      4: { cellWidth: "auto", halign: "right" },
    },
    margin: { top: 25, bottom: 10 }, // Add proper margins
    pageBreak: "auto", // Let autoTable handle page breaks
    tableWidth: "auto",
    rowPageBreak: "avoid", // Avoid breaking rows between pages
    horizontalPageBreak: true, // Enable horizontal page break
    horizontalPageBreakRepeat: true, // Repeat header on horizontal breaks
  });
  startY = pdf.lastAutoTable.finalY || 10;

  // pdf.setLineWidth(0.1);
  // pdf.setDrawColor(200, 200, 200);
  // pdf.line(14, startY, 196, startY);

  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);

  const { subTotal, shippingCost } = CalculateTaxAndPrice(
    data?.specifications,
    vendorId || from == "purchaseorder" ? "purchaseorder" : ""
  );

  const rightAlign = 140; // Adjust this value as needed
  startY = startY + 10;
  const lineHeight = 8;
  const gap = 30;

  // 40 is the height of the text (paid, balance etc)
  if (startY + lineHeight + 40 > pageHeight - margin) {
    pdf.addPage(); // Add a new page
    startY = margin; // Reset Y position
  }
  // Add financial details
  if (from == "retainer") {
    pdf.text(`Subtotal:`, rightAlign, startY);
    pdf.text(`${currencyFormat(data?.totalAmount)}`, rightAlign + gap, startY);
  } else {
    pdf.text(`Subtotal: `, rightAlign, startY);
    pdf.text(`${currencyFormat(subTotal)}`, rightAlign + gap, startY);
  }
  startY += lineHeight;

  // if (from != "proposal") {
  //   pdf.text(
  //     `Markup: ${toFixedDecimal(data?.markup || 0)}%`,
  //     rightAlign,
  //     startY
  //   );
  //   startY += lineHeight;
  // }

  pdf.text(`Shipping:`, rightAlign, startY);
  pdf.text(`${currencyFormat(shippingCost || 0)}`, rightAlign + gap, startY);
  startY += lineHeight;

  if (from !== "memo") {
    pdf.text(`Sales Tax:`, rightAlign, startY);
    pdf.text(`${currencyFormat(data?.tax || 0)}`, rightAlign + gap, startY);
    startY += lineHeight;
  }

  // Add total with bold font
  pdf.setFont("Aptos", "semibold");
  const tax = from == "memo" ? 0 : data.tax;

  if (from == "retainer") {
    pdf.text(`Total:`, rightAlign, startY);
    pdf.text(`${currencyFormat(data?.totalAmount)}`, rightAlign + gap, startY);
  } else {
    pdf.text(`Total:`, rightAlign, startY);
    pdf.text(
      `${currencyFormat(TotalPrice(subTotal, shippingCost, data.markup, tax))}`,
      rightAlign + gap,
      startY
    );
  }

  if (data?.amountPaid) {
    startY += lineHeight;
    pdf.text(`Paid:`, rightAlign, startY);
    pdf.text(
      `${currencyFormat(data?.amountPaid || 0)}`,
      rightAlign + gap,
      startY
    );
    startY += lineHeight;
    pdf.text(`Balance:`, rightAlign, startY);
    pdf.text(
      `${currencyFormat(
        TotalPrice(subTotal, shippingCost, data.markup, tax) -
          (data?.amountPaid || 0)
      )}`,
      rightAlign + gap,
      startY
    );
  }

  startY = startY + 10;

  // pdf.setLineWidth(0.1);
  // pdf.setDrawColor(200, 200, 200);
  // pdf.line(14, startY, 196, startY);

  pdf.setFontSize(10);
  pdf.setFont("Aptos", "normal");

  if (data?.memo && (from == "invoice" || from == "proposal")) {
    pdf.setTextColor(145, 150, 160); // Gray color
    startY += 10;
    pdf.text(`Memo:`, 14, startY);

    pdf.setTextColor(0, 0, 0); // Black color
    // Split text with different widths for first and subsequent lines
    const firstLineWidth = 168;
    const subsequentLineWidth = 180;

    // Get the full text
    const fullText = data?.termsConditions;

    // Split first line with smaller width
    const firstLine = pdf.splitTextToSize(fullText, firstLineWidth)[0];
    const remainingText = fullText.substring(firstLine.length).trim();

    // Split remaining text with larger width
    const remainingLines = pdf.splitTextToSize(
      remainingText,
      subsequentLineWidth
    );

    // Combine first line with remaining lines
    const allLines = [firstLine, ...remainingLines];
    allLines.forEach((splitLine, index) => {
      if (startY + lineHeight > pageHeight - margin) {
        pdf.addPage(); // Add a new page
        startY = margin; // Reset Y position
      }

      if (index == 0) {
        pdf.text(splitLine, 26, startY);
      } else {
        pdf.text(splitLine, 14, startY);
      }
      if (index != allLines.length - 1) {
        startY += lineHeight;
      }
    });
  }

  if (data?.termsConditions && (from == "invoice" || from == "proposal")) {
    pdf.setTextColor(145, 150, 160); // Gray color
    startY += 10;
    pdf.text(`Terms & Conditions:`, 14, startY);
    // startY = startY + 16;
    pdf.setTextColor(0, 0, 0); // Black color

    // Split text with different widths for first and subsequent lines
    const firstLineWidth = 148;
    const subsequentLineWidth = 180;

    // Get the full text
    const fullText = data?.termsConditions;

    // Split first line with smaller width
    const firstLine = pdf.splitTextToSize(fullText, firstLineWidth)[0];
    const remainingText = fullText.substring(firstLine.length).trim();

    // Split remaining text with larger width
    const remainingLines = pdf.splitTextToSize(
      remainingText,
      subsequentLineWidth
    );

    // Combine first line with remaining lines
    const allLines = [firstLine, ...remainingLines];

    allLines.forEach((splitLine, index) => {
      if (startY + lineHeight > pageHeight - margin) {
        pdf.addPage(); // Add a new page
        startY = margin; // Reset Y position
      }
      if (index == 0) {
        pdf.text(splitLine, 46, startY);
      } else {
        pdf.text(splitLine, 14, startY);
      }

      if (index != allLines.length - 1) {
        startY += lineHeight;
      }
    });
  }

  const totalPages = pdf.getNumberOfPages();

  for (let i = 1; i <= totalPages; i++) {
    pdf.setPage(i);
    if (i == 1) {
      pdf.text(
        `Page: 1 of ${totalPages}`,
        from == "purchaseorder" ? 140 : 150,
        from == "purchaseorder" ? 25 : 30
      );
    }
    drawHeader(
      pdf,
      companyInfo,
      maps[from]?.toUpperCase() || "DOCUMENT", // e.g., "PURCHASE ORDER"
      data.code?.toUpperCase() || "",
      i,
      totalPages
    );
    drawFooter(
      pdf,
      companyInfo?.company_details?.name,
      companyInfo?.company_details?.address?.[0]
    );
  }

  return pdf.output("blob");
};

// export const CalculateTaxAndPrice = (specifications, from?) => {
//   const subTotal =
//     from == "purchaseorder"
//       ? specifications.reduce(
//           (acc, item) => acc + (+item?.totalUnitCost || 0),
//           0
//         )
//       : specifications?.reduce(
//           (acc, item) => acc + (+item?.totalSellingPrice || 0),
//           0
//         );
//   const shippingCost = specifications?.reduce(
//     (acc, item) => acc + (+item?.shippingCost || 0),
//     0
//   );

//   const totalShippingTax = specifications.reduce((total, spec) => {
//     return (
//       total +
//       +spec.shippingTax?.reduce(
//         (acc, item) => acc + (+item?.rate?.value || 0),
//         0
//       )
//     );
//   }, 0);
//   const totalSalesTax = specifications.reduce((total, spec) => {
//     return (
//       total +
//       +spec.salesTax?.reduce((acc, item) => acc + (+item?.rate?.value || 0), 0)
//     );
//   }, 0);
//   return {
//     subTotal,
//     shippingCost,
//     totalSalesTax,
//     totalShippingTax,
//   };
// };

export const CalculateTaxAndPrice = (
  specifications: any,
  from?: "purchaseorder" | "invoice" | "proposal" | "",
  taxesData?: any,
  isCustomTaxCategory?: boolean,
  selectedTax?: any
) => {
  const initialValues = {
    subTotal: 0,
    shippingCost: 0,
    totalSalesTax: 0,
    totalShippingTax: 0,
    totalClientSaving: 0,
    totalCost: 0,
    totalMarkup: 0,
  };

  const result = specifications?.reduce((acc, spec) => {
    const unitCost =
      from === "purchaseorder"
        ? +spec.totalUnitCost || 0
        : +spec.totalSellingPrice || 0;
    const shippingCost =
      from == "purchaseorder"
        ? +spec.shippingCost || 0
        : +spec.shippingPrice || 0;
    // const salesTax =
    //   spec.salesTax?.reduce(
    //     (taxAcc, item) => taxAcc + (+item.rate?.value || 0),
    //     0
    //   ) || 0;
    // const shippingTax =
    //   spec.shippingTax?.reduce(
    //     (taxAcc, item) => taxAcc + (+item.rate?.value || 0),
    //     0
    //   ) || 0;
    const totalClientSaving = +spec.totalClientSaving || 0;

    return {
      subTotal: acc.subTotal + unitCost,
      shippingCost: acc.shippingCost + shippingCost,
      totalSalesTax:
        acc.totalSalesTax +
        (taxesData
          ? calculateTotalTax(
              spec,
              taxesData,
              "salesTax",
              spec.sellingPrice,
              isCustomTaxCategory,
              selectedTax
            )
          : 0),
      totalShippingTax:
        acc.totalShippingTax +
        (taxesData
          ? calculateTotalTax(
              spec,
              taxesData,
              "shippingTax",
              shippingCost,
              isCustomTaxCategory,
              selectedTax
            )
          : 0),
      totalClientSaving: acc.totalClientSaving + totalClientSaving,
      totalCost:
        acc.totalCost + (+spec.totalUnitCost || 0) + (+spec.shippingCost || 0),
      totalMarkup: +acc.totalMarkup + +calculateTotalMarkup(spec),
    };
  }, initialValues);

  return result || initialValues;
};
const calculateTotalTax = (
  specifications: any,
  taxesData: any,
  taxCategory: "salesTax" | "shippingTax",
  price: number,
  isCustomTaxCategory?: boolean,
  selectedTax?: any
) => {
  const projectData = useProjectStore.getState()?.projectData;

  const taxData = taxesData?.filter((item: any) =>
    isCustomTaxCategory
      ? selectedTax?.find((applied) => applied.value === item?._id?.toString())
      : projectData?.salesTax?.includes(item?._id?.toString())
  );
  if (taxCategory == "salesTax") {
    let totalTaxAmount = 0;
    taxData?.forEach((tax: any) => {
      tax.zones?.forEach((zone: any) => {
        // 1. Check if zone name and parent id match any in salesTaxApplied
        // const match = isCustomTaxCategory
        //   ? true
        //   : specifications?.salesTaxApplied?.find(
        //       (applied) =>
        //         applied.label === zone.name &&
        //         applied.parent_id === tax._id.toString()
        //     );
        // if (!match) return;

        const match = isCustomTaxCategory
          ? true
          : specifications?.salesTaxApplied === true
            ? true
            : false;
        if (!match) return;

        // 2. Check appliesTo and specificationType
        const applies =
          (zone.appliesTo?.products &&
            specifications.specificationType === "product") ||
          (zone.appliesTo?.services &&
            specifications.specificationType === "service");

        if (!applies) return;

        let taxableAmount = 0;
        if (zone.calculationRule == "Per Unit") {
          taxableAmount = price; // price is per unit
        } else if (zone.calculationRule == "Per Total") {
          taxableAmount = (specifications?.quantity?.value || 1) * price;
        } else if (zone.calculationRule == "Per Invoice") {
          taxableAmount = specifications?.totalSellingPrice; // For invoice, pass total invoice price
        }
        const limit = zone?.taxableLimit?.amount ?? Infinity;
        let amountToTax = 0;
        // 3. Calculate tax

        // if (zone.calculationRule == "Per Unit") {
        //   totalTaxAmount += +toFixedDecimal(
        //     (specifications?.quantity?.value || 1) *
        //       price *
        //       (zone.taxPercentage / 100)
        //   );
        // } else if (zone.calculationRule == "Per Total") {
        //   totalTaxAmount += +toFixedDecimal(
        //     (specifications?.quantity?.value || 1) *
        //       price *
        //       (zone.taxPercentage / 100)
        //   );
        // } else if (zone.calculationRule == "Per Invoice") {
        //   totalTaxAmount += +toFixedDecimal(
        //     price * (zone.taxPercentage / 100)
        //   );
        // }
        if (zone?.taxableLimit?.unit == "Below") {
          // If taxableAmount is greater than the limit, only tax up to the limit
          amountToTax = taxableAmount > limit ? limit : taxableAmount;
        } else if (zone?.taxableLimit?.unit == "Above") {
          amountToTax = taxableAmount > limit ? taxableAmount - limit : 0;
        }

        if (amountToTax > 0) {
          if (zone.calculationRule == "Per Unit") {
            totalTaxAmount += +toFixedDecimal(
              (specifications?.quantity?.value || 1) *
                amountToTax *
                (zone.taxPercentage / 100)
            );
          } else if (
            zone.calculationRule == "Per Total" ||
            zone.calculationRule == "Per Invoice"
          ) {
            totalTaxAmount += +toFixedDecimal(
              amountToTax * (zone.taxPercentage / 100)
            );
          }
        }
      });
    });

    return +toFixedDecimal(totalTaxAmount);
  } else {
    let totalTaxAmount = 0;

    taxData?.forEach((tax: any) => {
      tax.zones?.forEach((zone: any) => {
        // 1. Check if zone name and parent id match any in salesTaxApplied
        // const match = isCustomTaxCategory
        //   ? true
        //   : specifications?.shippingTaxApplied?.find(
        //       (applied) =>
        //         applied.label === zone.name &&
        //         applied.parent_id === tax._id.toString()
        //     );
        // if (!match) return;

        const match = isCustomTaxCategory
          ? true
          : specifications?.shippingTaxApplied === true
            ? true
            : false;
        if (!match) return;

        // 2. Check appliesTo and specificationType

        if (!zone.appliesTo?.shipping) return;

        // 3. Calculate tax
        // if (zone.calculationRule == "Per Unit") {
        //   totalTaxAmount += +toFixedDecimal(
        //     (specifications?.quantity?.value || 1) *
        //       price *
        //       (zone.taxPercentage / 100)
        //   );
        // } else {
        //   totalTaxAmount += +toFixedDecimal(price * (zone.taxPercentage / 100));
        // }
        let taxableAmount = 0;
        if (zone.calculationRule == "Per Unit") {
          taxableAmount = price; // price is per unit
        } else if (zone.calculationRule == "Per Total") {
          taxableAmount = (specifications?.quantity?.value || 1) * price;
        } else if (zone.calculationRule == "Per Invoice") {
          taxableAmount = specifications?.totalSellingPrice; // For invoice, pass total invoice price
        }
        const limit = zone?.taxableLimit?.amount ?? Infinity;
        let amountToTax = 0;
        if (zone?.taxableLimit?.unit == "Below") {
          // If taxableAmount is greater than the limit, only tax up to the limit
          amountToTax = taxableAmount > limit ? limit : taxableAmount;
        } else if (zone?.taxableLimit?.unit == "Above") {
          amountToTax = taxableAmount > limit ? taxableAmount - limit : 0;
        }
        if (amountToTax > 0) {
          if (zone.calculationRule == "Per Unit") {
            totalTaxAmount += +toFixedDecimal(
              (specifications?.quantity?.value || 1) *
                amountToTax *
                (zone.taxPercentage / 100)
            );
          } else if (
            zone.calculationRule == "Per Total" ||
            zone.calculationRule == "Per Invoice"
          ) {
            totalTaxAmount += +toFixedDecimal(
              amountToTax * (zone.taxPercentage / 100)
            );
          }
        }
      });
    });

    return +toFixedDecimal(totalTaxAmount);
  }
};
export const TotalPrice = (subTotal, shippingCost, markup, tax) => {
  return toFixedDecimal(
    +subTotal + +shippingCost + (+subTotal * +(markup || 0)) / 100 + +(tax || 0)
  );
};
const calculateTotalMarkup = (spec) => {
  if (spec?.shippingMarkup?.unit == "%") {
    return (
      (+spec?.totalMarkUp || 0) +
      +toFixedDecimal(
        ((+spec?.shippingMarkup?.value || 0) * (+spec?.shippingCost || 0)) / 100
      )
    );
  } else {
    return (+spec?.shippingMarkup?.value || 0) + (+spec?.totalMarkUp || 0);
  }
};

// export const handleInvoicePDFExport = (data, iframeRef?) => {
//   const pdf: any = new jsPDF();

//   console.log("invoiceData", data);

//   // Define positions and dimensions
//   const leftColumnX = 14;
//   const rightColumnX = 155;
//   let startY = 20;
//   const lineSpacing = 6;

//   pdf.setFontSize(18);
//   pdf.setTextColor("#1E1E20");
//   pdf.text("My Interior Company", leftColumnX, startY);
//   pdf.setFontSize(12);
//   pdf.text("myintcompany@gmail.com", leftColumnX, startY + lineSpacing);

//   pdf.text(
//     `Due Date: ${
//       data?.dueDate ? moment(data.dueDate).format("DD/MM/YYYY") : ""
//     }`,
//     rightColumnX,
//     startY
//   );

//   pdf.text(
//     `Invoice No:: ${data?.invoiceNumber || ""}`,
//     rightColumnX,
//     startY + lineSpacing
//   );

//   startY = startY + 2 * lineSpacing;
//   pdf.setDrawColor("#D0D1C9");

//   pdf.line(leftColumnX, startY, 200, startY);

//   startY = startY + 10;

//   pdf.text("Bill To:", leftColumnX, startY);
//   pdf.text(`${data?.client?.name},`, leftColumnX, startY + lineSpacing);

//   pdf.text(
//     `${data?.client?.phone_numbers?.[0] || ""},`,
//     leftColumnX,
//     startY + 2 * lineSpacing
//   );

//   pdf.text(
//     `${data?.client?.email || ""},`,
//     leftColumnX,
//     startY + 3 * lineSpacing
//   );

//   pdf.text("Billing Address:", rightColumnX, startY);
//   pdf.text(
//     `${data?.client?.address || ""},`,
//     rightColumnX,
//     startY + lineSpacing
//   );

//   pdf.text(
//     `${data?.client?.city ? data?.client?.city + "," : ""} ${
//       data?.client?.state ? data?.client?.state + "," : ""
//     } ${data?.client?.zip ? data?.client?.zip : ""}`,
//     rightColumnX,
//     startY + 2 * lineSpacing,
//     { maxWidth: 45 }
//   );

//   startY = startY + 4 * lineSpacing;

//   pdf.line(leftColumnX, startY, 200, startY);

//   const tableHeaders = ["Item", "Unit Cost", "Qty", "Total"];
//   // new code
//   const tableRows = [];
//   data?.specifications?.forEach((product) => {
//     let col1Content = `${
//       product.images?.[0] ? product.images?.[0] + "‑" : ""
//     }\n${product.title}\n${product.clientDescription?.trim()}`;
//     const productData = [
//       {
//         content: col1Content,
//         styles: { cellWidth: 40, halign: "center", valign: "middle" },
//       },
//       {
//         content: `${UnitValues[product?.unitPrice?.unit || ""]}${
//           product?.unitPrice?.value || ""
//         }`,
//         styles: { fontStyle: "normal", halign: "center", valign: "middle" },
//       },
//       {
//         content: `x${product?.quantity?.value || ""}`,
//         styles: { fontStyle: "normal", halign: "center", valign: "middle" },
//       },

//       {
//         content: `${UnitValues[product?.unitPrice?.unit || ""]}${
//           +product?.unitPrice?.value * +product?.quantity?.value
//         }`,
//         styles: { fontStyle: "normal", halign: "center", valign: "middle" },
//       },
//     ];
//     tableRows.push(productData);
//   });

//   const addImage = (data) => {
//     for (let i = 1; i < data.table.body.length; i++) {
//       const imageUrl = data.table.body[i - 1][0]?.content?.split("‑")[0];
//       console.log(
//         "data---",
//         data.table.body[i - 1]?.raw?.[0]?.content?.split("‑")[0]
//       );
//       if (imageUrl) {
//         pdf.addImage(imageUrl, "PNG", data.cell.x + 2, data.cell.y + 2, 16, 16);
//       }
//     }
//   };

//   pdf.autoTable({
//     startY: startY + 10,
//     head: [tableHeaders],
//     body: tableRows,
//     didDrawCell: (data) => {
//       if (
//         data.column.index === 0 &&
//         data.cell.section === "body" &&
//         data.cell.raw.content.includes("‑")
//       ) {
//         addImage(data);
//       }
//       if (data.cell.section === "head") {
//         data.cell.styles.lineWidth = 0.5;
//         data.cell.styles.lineColor = [0, 0, 0];
//       }
//     },
//     theme: "grid",
//     headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
//     bodyStyles: { fillColor: [255, 255, 255] },
//   });

//   const pdfBlob = pdf.output("blob");

//   // Create a Blob URL from the PDF file
//   const pdfUrl = URL.createObjectURL(pdfBlob);

//   // Set the Blob URL to the iframe's src to athe PDF
//   if (iframeRef?.current) {
//     iframeRef.current.src = pdfUrl;
//   }

//   return pdfUrl;
// };

export const handlePDFData = (
  from: string,
  data: any,
  projectData?: any,
  vendorId?: string
) => {
  return handlePDFExport(
    projectData?.shippingAddress,
    projectData?.billingAddress ??
      projectData?.client?.address?.find((item) => item.isPrimary),
    data,
    vendorId || "",
    projectData?.client,
    from
  );
};

export const updateFile = async (postData, projectData, from, vendorId?) => {
  const fileBlob = await handlePDFData(
    from,
    {
      ...postData,
      client: postData?.client,
      vendor: postData?.vendor,
    },

    projectData,
    vendorId
  );
  await updateSingleItemToBucket(fileBlob, "pdf", postData?.fileData?.url);
};

// Function to fetch image and convert it to base64
const fetchImageAsBase64 = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

// Function to draw circular image
const drawCircularImage = (pdf, base64Img, x, y, maxSize) => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    // Add error handling for CORS
    img.onerror = (err) => {
      console.error("Error loading image:", err);
      // If the image fails to load, just continue without the logo
      resolve(false);
    };

    // If the image is already a base64 string, use it directly
    if (base64Img.startsWith("data:image")) {
      img.src = base64Img;
    } else {
      // For URLs, try to fetch the image with CORS headers
      fetch(base64Img, {
        mode: "cors",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            if (typeof reader.result === "string") {
              img.src = reader.result;
            }
          };
          reader.readAsDataURL(blob);
        })
        .catch((err) => {
          console.error("Error fetching image:", err);
          resolve(false);
        });
    }

    img.onload = () => {
      const naturalWidth = img.naturalWidth;
      const naturalHeight = img.naturalHeight;
      const minSize = Math.min(naturalWidth, naturalHeight);
      const diameter = Math.min(minSize, maxSize);

      // Increase resolution by using a high-DPI canvas
      const scaleFactor = 10; // Adjust for better quality
      const canvas = document.createElement("canvas");
      canvas.width = diameter * scaleFactor;
      canvas.height = diameter * scaleFactor;
      const ctx = canvas.getContext("2d");

      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // Create high-quality circular clipping path
        ctx.beginPath();
        ctx.arc(
          canvas.width / 2,
          canvas.height / 2,
          (diameter / 2) * scaleFactor,
          0,
          Math.PI * 2
        );
        ctx.closePath();
        ctx.clip();

        // Draw the image inside the clipped circle
        ctx.drawImage(
          img,
          (naturalWidth - minSize) / 2,
          (naturalHeight - minSize) / 2,
          minSize,
          minSize,
          0,
          0,
          canvas.width,
          canvas.height
        );

        // Convert the high-resolution image back to base64
        const circularImgData = canvas.toDataURL("image/png", 1.0); // Use highest quality

        // Add the high-quality circular image to the PDF
        resolve(circularImgData);
      } else {
        reject(new Error("Canvas context not supported"));
      }
    };
  });
};

const drawFooter = (pdf, name, address) => {
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // Draw the line
  pdf.setDrawColor(200, 200, 200);
  pdf.setLineWidth(0.3);
  pdf.line(14, pageHeight - 15, pageWidth - 14, pageHeight - 15);

  // Draw the footer text
  pdf.setFontSize(8);
  pdf.setFont("Aptos", "normal");
  pdf.text(name, pageWidth / 2, pageHeight - 10, {
    align: "center",
  });

  pdf.text(
    `${address?.address_line || ""}, ${address?.city || ""}, ${address?.state || ""} ${address?.zip || ""}`,
    pageWidth / 2,
    pageHeight - 6,
    { align: "center" }
  );
};
const drawHeader = (
  pdf,
  companyInfo,
  docType,
  docCode,
  pageNum,
  totalPages
) => {
  if (pageNum === 1) return; // Skip header on first page

  const pageWidth = pdf.internal.pageSize.getWidth();

  // Draw the line
  // pdf.setDrawColor(200, 200, 200);
  // pdf.setLineWidth(0.3);
  // pdf.line(14, 20, pageWidth - 14, 20);

  // Right-aligned document info
  pdf.setFont("Aptos", "semibold");
  pdf.setFontSize(10);
  pdf.text(`${docType}: ${docCode}`, pageWidth - 14, 10, { align: "right" });
  pdf.setFont("Aptos", "normal");
  pdf.setFontSize(8);
  pdf.text(`Page: ${pageNum} of ${totalPages}`, pageWidth - 14, 15, {
    align: "right",
  });
};

export const TearsheetPDF = async (
  specifications: any[],
  images: { _id: string; images: string[] },
  projectName?: string
) => {
  const pdf: any = new jsPDF();
  const companyInfo = useUserStore.getState()?.user;

  let imgData: any;
  if (companyInfo?.company_details?.base64CompanyLogo) {
    imgData = await drawCircularImage(
      pdf,
      companyInfo?.company_details?.base64CompanyLogo ||
        companyInfo?.company_logo,
      14,
      10,
      22
    );
  }
  // Iterate through each specification
  specifications?.forEach(async (spec, index) => {
    // Add new page for each spec after the first one
    if (index > 0) {
      pdf.addPage();
    }

    // Header with company logo and info
    pdf.setFontSize(24);
    pdf.setTextColor(0, 0, 0);

    // Add company logo (use actual logo or placeholder)

    if (companyInfo?.company_details?.base64CompanyLogo) {
      try {
        // const imgData = await fetchImageAsBase64(companyInfo.company_logo);
        if (imgData) {
          pdf.addImage(imgData, "PNG", 14, 10, 20, 20);
        } else {
          pdf.text(companyInfo?.company_name || "Genus Tech", 45, 22); // Adjust x position to make space for the logo
          pdf.setFontSize(10);
        }

        // Adjust position and size as needed
        // pdf.addImage(
        //   companyInfo.base64CompanyLogo,
        //   "PNG",
        //   14,
        //   10,
        //   20,
        //   20,
        //   undefined,
        //   "FAST"
        // );

        // pdf.text(companyInfo?.company_email || companyInfo?.email, 45, 28);
      } catch (error) {
        console.error("Error loading company logo:", error);
        pdf.text(companyInfo?.company_name || "Genus Tech", 14, 23);
        pdf.setFontSize(10);
        // pdf.text(companyInfo?.company_email || companyInfo?.email, 14, 28);
      }
    } else {
      pdf.text(companyInfo?.company_name || "Genus Tech", 14, 23);
      pdf.setFontSize(10);
      // pdf.text(companyInfo?.company_email || companyInfo?.email, 14, 28);
    }

    // Add company address in top right
    pdf.setFontSize(10);
    let address = "";
    console.log(companyInfo?.company_details);
    if (companyInfo?.company_details?.address[0]) {
      address = `${companyInfo?.company_details?.address[0]?.address_line}, ${companyInfo?.company_details?.address[0]?.city}, ${companyInfo?.company_details?.address[0]?.state}`;
    }
    if (companyInfo?.company_details?.phone_number) {
      address += ` + P: ${formatPhone(companyInfo?.company_details?.phone_number)}`;
    }

    pdf.setTextColor(128, 128, 128); // Set text color to gray
    pdf.text(address, 196, 23, { align: "right" }); // Changed Y position from 20 to 23 to match heading
    pdf.setTextColor(0, 0, 0); // Reset text color to black
    pdf.setLineWidth(0.1);
    pdf.setDrawColor(200, 200, 200); // Gray color
    pdf.line(14, 35, 196, 35);

    // Main product section
    let startY = 50;

    // Add white background for main product image
    pdf.setFillColor(255, 255, 255);
    pdf.rect(14, startY, 120, 120, "F");

    // Add main product image
    const productImages = images[spec._id]?.images;
    if (productImages?.[0]) {
      pdf.addImage(productImages[0], "JPEG", 14, startY, 120, 120);
    } else {
      pdf.addImage(ImgPlaceholder, "PNG", 14, startY, 120, 120);
    }

    // Add white background for smaller product images
    const smallImageWidth = 40;
    const smallImageHeight = 40;
    const rightColumnX = 140;

    productImages?.slice(1, 5)?.forEach((img, idx) => {
      // Add white background for each small image
      pdf.setFillColor(255, 255, 255);
      pdf.rect(
        rightColumnX,
        startY + idx * (smallImageHeight + 5),
        smallImageWidth,
        smallImageHeight,
        "F"
      );

      pdf.addImage(
        img,
        "JPEG",
        rightColumnX,
        startY + idx * (smallImageHeight + 5),
        smallImageWidth,
        smallImageHeight
      );
    });

    // Product details section
    startY = 180;
    pdf.setLineWidth(0.1);
    pdf.setDrawColor(0, 0, 0);
    pdf.line(14, startY, 196, startY);
    startY += 10;

    pdf.setFontSize(14);
    pdf.setFont("helvetica", "bold");
    pdf.text(spec.title || "", 14, startY);

    startY += 10;
    pdf.setFontSize(10);
    pdf.setFont("helvetica", "normal");
    pdf.text(`Price: ${currencyFormat(spec.sellingPrice || 0)}`, 14, startY);

    startY += 6;
    pdf.text(`Dimensions: ${spec.dimensions || "Not Available"}`, 14, startY);

    startY += 6;
    pdf.text(
      `Material/Finish: ${spec.materialFinish || "Not Available"}`,
      14,
      startY
    );

    startY += 6;
    // Add Description heading
    pdf.setFontSize(10);
    pdf.text(
      "Details: " + (spec.clientDescription || "Not Available"),
      14,
      startY
    );
    startY += 6;

    // Product details with word wrapping
    pdf.setFont("helvetica", "normal");
    const detailsWidth = 180;
    const splitDetails = pdf.splitTextToSize(
      spec.clientDescription || "Not Available",
      detailsWidth
    );
    splitDetails.forEach((line, index) => {
      if (line && index > 0) {
        // Skip first line since it's already shown
        pdf.text(line, 14, startY);
        startY += 6;
      }
    });
  });

  return pdf.output("blob");
};
